import React from 'react';
import { useFontSize } from '../../contexts/FontSizeContext';
import { getTextSizeClass, getSubsectionHeadingSizeClass } from '../../utils/fontSizeUtils';

interface DeleteListConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  listName: string;
}

const DeleteListConfirmationModal: React.FC<DeleteListConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  listName,
}) => {
  const { fontSize } = useFontSize();
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 dark:bg-gray-900/70">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md m-4">
        <div className="p-6">
          <div className="flex">
            <div className="mr-4 flex-shrink-0">
              <div className="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
                <svg 
                  className="w-6 h-6 text-red-600 dark:text-red-400" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" 
                  />
                </svg>
              </div>
            </div>
            <div>
              <h3 className={`${getSubsectionHeadingSizeClass(fontSize)} font-semibold text-gray-900 dark:text-white`} id="modal-title">
                Delete List
              </h3>
              <div className="mt-2">
                <p className={`${getTextSizeClass(fontSize)} text-gray-500 dark:text-gray-300`}>
                  Are you sure you want to delete the{' '}
                  <span className="font-bold text-gray-900 dark:text-white">"{listName}"</span> list? This action cannot be undone.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 dark:bg-gray-700 px-6 py-4 flex justify-end space-x-3 rounded-b-lg">
          <button
            onClick={onClose}
            className={`px-4 py-2 ${getTextSizeClass(fontSize)} font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-600 border border-gray-300 dark:border-gray-500 rounded-md shadow-sm hover:bg-gray-50 dark:hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:focus:ring-offset-gray-800`}
            type="button"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 ${getTextSizeClass(fontSize)} font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 dark:focus:ring-offset-gray-800`}
            type="button"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteListConfirmationModal;
